// Import Swiper styles
import "swiper/css";
import "swiper/css/a11y";
import "swiper/css/navigation";
import "../../../theme/SwiperOverrides.css";

import * as styles from "./ParagraphImages.module.scss";

import React, { useState } from "react";
// import Swiper core and required modules
import { A11y, Navigation, Virtual } from "swiper/modules";
import { Swiper, type SwiperClass, SwiperSlide } from "swiper/react";
import ImageCarouselModal, {
	type ImageProps,
} from "../../../components/ImageCarouselModal/ImageCarouselModal";
import { Pagination } from "../../../components/Pagination/Pagination";
import SwiperImage from "../../../components/SwiperImage/SwiperImage";
import { Expand } from "../../../components/common/Icons";
import { useClientSide } from "../../../hooks/useClientSide";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface ParagraphImagesProps {
	images: ImageProps[];
}

export const getParagraphImagesProps = (
	data: Queries.ParagraphImagesDataFragment,
): ParagraphImagesProps => ({
	images: data?.relationships?.field_image.map((image) => ({
		src: image?.field_media_image?.uri || "",
		alt: image?.field_media_image?.alt || "",
	})),
});
export const ParagraphImages: React.FC<ParagraphImagesProps> = ({ images }) => {
	const [currentSlide, setCurrentSlide] = useState(0);
	const [swiper, setSwiper] = useState<SwiperClass>();
	const [expanded, setExpanded] = useState(false);
	const isClientSide = useClientSide();

	if (images.length === 1)
		return (
			<WrappedSection sectionName="ParagraphImages">
				<div className={styles.paragraphimagesinner}>
					<div className={styles.swiper}>
						{images[0] && <SwiperImage {...images[0]} isStandalone={true} />}
					</div>
				</div>
			</WrappedSection>
		);

	return (
		<>
			<ImageCarouselModal
				expanded={expanded}
				images={images}
				onHide={() => setExpanded(false)}
			/>
			<WrappedSection sectionName="ParagraphImages">
				<div className={styles.paragraphimagesinner}>
					{isClientSide && (
						<Swiper
							className={styles.swiper}
							modules={[Virtual, Navigation, A11y]}
							spaceBetween={0}
							slidesPerView={1}
							effect="slide"
							onSlideChange={(swiper) => setCurrentSlide(swiper.activeIndex)}
							onSwiper={setSwiper}
						>
							{images.map((image) => (
								<SwiperSlide key={image.src}>
									<SwiperImage {...image} isStandalone={true} />
								</SwiperSlide>
							))}
							<button 
								type="button"
								className={styles.expand}
								onClick={() => setExpanded(true)}

								onKeyDown={(e) => {
									if (e.key === "Enter") setExpanded(true);
								}}
							>
								<Expand height={"24px"} width={"24px"} />
							</button>
						</Swiper>
					)}
					<div className={styles.pagination}>
						<Pagination
							onFirstClick={() => swiper?.slideTo(0)}
							onPreviousClick={() => swiper?.slidePrev()}
							onNextClick={() => swiper?.slideNext()}
							onLastClick={() => swiper?.slideTo(images.length - 1)}
							firstDisabled={currentSlide === 0}
							previousDisabled={currentSlide === 0}
							nextDisabled={currentSlide === images.length - 1}
							lastDisabled={currentSlide === images.length - 1}
							position={currentSlide}
							total={images.length}
							slim={true}
						/>
					</div>
				</div>
			</WrappedSection>
		</>
	);
};

export default ParagraphImages;
